import * as React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { InputButton } from '@vio/atlas/helpers/InputButton';
import { Icon } from '@vio/atlas/Icon';
interface Props {
  /** Date to be displayed in the FakeInput */
  value: string;
  /** The click handler */
  onClick: () => void;
  /** Error flag */
  hasError?: boolean;
}
const destinationPickerMessages = defineMessages({
  destinationPlaceholder: {
    id: 'whereAreYouGoing',
    defaultMessage: 'Where are you going?'
  }
});
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w12byz2d",
  propsAsIs: false
});
const DestinationValue = /*#__PURE__*/styled('div')({
  name: "DestinationValue",
  class: "dkucbet",
  propsAsIs: false
});

// TODO: Remove getLinariaClassName when migrating to linaria
const _exp2 = /*#__PURE__*/() => InputButton;
const FormButton = /*#__PURE__*/styled(_exp2())({
  name: "FormButton",
  class: "f1lwitlr",
  propsAsIs: true
});
export const FakeDestinationInput = ({
  value,
  onClick,
  hasError = false
}: Props) => {
  const {
    formatMessage
  } = useIntl();
  return <Wrapper>
      <FormButton size="lg" dataId="DestinationPickerTrigger" id="DestinationPickerTrigger" placeholder={formatMessage(destinationPickerMessages.destinationPlaceholder)} icon={<Icon colorPath="content.neutral.c600" name="Pin" />} onClick={onClick} className={cx(hasError && 'hasError')}>
        {value && <DestinationValue data-id="DestinationPickerTriggerValue">
            {value}
          </DestinationValue>}
      </FormButton>
    </Wrapper>;
};

require("./FakeDestinationInput.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FakeDestinationInput.tsx");